import axios from '../api/axiosInstance';
import { API_ENDPOINTS } from '../api/apiEndpoints';
import { getApplicationIdWithFallback } from '../utils/moduleUtils';

export const fetchCategories = async (moduleKey) => {
  try {
    const applicationId = getApplicationIdWithFallback(moduleKey);
    const response = await axios.get(API_ENDPOINTS.categories(applicationId));
    return response.data.data;
  } catch (error) {
    console.error('Error fetching categories::', error);
    throw error;
  }
};
